import React from 'react';
import './DataSourcePage.css';
import { Link, Outlet } from 'react-router-dom';

// Define the props for the component if needed, currently empty
interface UserPageProps {}

const UserPage: React.FC<UserPageProps> = () => {
    return (
        <div className="data-source-page">
            <div className="data-source-container">
                <div className="data-source-sidebar">
                    <h2>Personalization</h2>
                    <ul>
                        <li>
                            <Link to="/user/change-password" className="sub-menu-link">Change Password</Link>
                        </li>
                        <li>
                            {/* Use a span tag for the feature under development */}
                            <span className="sub-menu-link disabled">Profile</span>
                        </li>
                    </ul>
                </div>
                <div className="data-source-main-content">
                    <Outlet/>
                </div>
            </div>
        </div>
    );
};

export default UserPage;
